import React, { useContext, useEffect, useState } from "react";
import { Logo } from "../../../assets/images";
import { RootState } from "../../../redux/store/store";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import OfferCard from "../../../componet/offer-card";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import { useSelector } from "react-redux";
import OfferStudentModal from "../../../componet/offer-student-modal";
import {
  createStudentOfferService,
  getAllStudentOfferService,
  sendOfferService,
  getAllStudentCurrentRequests,
} from "../../../services/student-offer";
import { getSpecialPromoCode } from "../../../services/promo-code-service";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import { SnackbarContext } from "../../../config/hooks/use-toast";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const OfferStudent = () => {
  const role = useSelector(
    (state: RootState) => state?.user?.userData?.role.name,
  );
  const userData = useSelector((state: RootState) => state?.user?.userData);

  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState<any>(null);
  const [selectedOffer, setSelectedOffer] = useState<any>(null);
  const [isConfirmModal, setIsConfirmModal] = useState(false);

  const [isPeriodModalOpen, setIsPeriodModalOpen] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState<
    "MONTHLY" | "TRIMESTER" | "SEMESTER" | "YEARLY"
  >("MONTHLY");
  const [paymentFile, setPaymentFile] = useState<File | null>(null);
  const [paymentMethod, setPaymentMethod] = useState<"online" | "upload">(
    "upload",
  );
  const [promoCode, setPromoCode] = useState("");
  const [specialPromoCode, setSpecialPromoCode] = useState<string | null>(null);
  const [isSpecialPromoActive, setIsSpecialPromoActive] = useState(false);

  const snackbarContext = useContext(SnackbarContext);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [offersRes, requestsRes] = await Promise.all([
        getAllStudentOfferService(),
        role === "ROLE_STUDENT" ? getAllStudentCurrentRequests() : Promise.resolve({ data: [] }),
      ]);

      const offers = Array.isArray(offersRes.data) ? offersRes.data : [];
      const requests = Array.isArray(requestsRes.data) ? requestsRes.data : [];

      const mergedData = offers.map((offer: any) => {
        const studentReq = requests.find(
          (r: any) => (r.studentOffer?.id || r.offerId) === offer.id,
        );
        return {
          ...offer,
          status: studentReq ? studentReq.status : null,
        };
      });

      setData(mergedData);
    } catch (e: any) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateOffer = (updatedOffer: any) => {
    setData((prevOffers: any[]) =>
      prevOffers.map((offer) =>
        offer.id === updatedOffer.id ? updatedOffer : offer,
      ),
    );
  };

  const handleUpdateAfterDelete = () => {
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [role]);

  useEffect(() => {
    if (role === "ROLE_STUDENT" && userData?.id) {
      getSpecialPromoCode(userData.id)
        .then((data) => {
          const code = (data as any)?.code;
          if (code) {
            setSpecialPromoCode(code);
            if (!promoCode || promoCode === code) {
              setPromoCode(code);
              setIsSpecialPromoActive(true);
            }
          }
        })
        .catch((err: any) => {
          console.error(err);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role, userData?.id]);

  useEffect(() => {
    if (isSpecialPromoActive && selectedPeriod === "YEARLY") {
      setSelectedPeriod("MONTHLY");
    }
  }, [isSpecialPromoActive, selectedPeriod]);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleAction = (formData: any) => {
    createStudentOfferService(formData)
      .then(() => {
        fetchData();
        handleCloseModal();
        snackbarContext?.showMessage(
          "Succes",
          "Offre ajoutee avec succes",
          "success",
        );
      })
      .catch((err: any) => {
        console.error(err);
      });
  };

  const handleCloseProfileDialog = () => {
    setSelectedProfile(null);
  };

  const handleOfferClick = (offer: any) => {
    setSelectedOffer(offer);
    const isFreeOffer =
      offer.price === 0 ||
      (offer.monthlyPrice === 0 &&
        offer.trimesterPrice === 0 &&
        offer.semesterPrice === 0 &&
        offer.yearlyPrice === 0);

    if (isFreeOffer) {
      setIsConfirmModal(true);
    } else {
      setIsPeriodModalOpen(true);
      setSelectedPeriod("MONTHLY");
      setPaymentFile(null);
      setPaymentMethod("upload");
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setPaymentFile(e.target.files[0]);
    }
  };

  const handlePeriodConfirm = () => {
    if (isSpecialPromoActive && selectedPeriod === "YEARLY") {
      snackbarContext?.showMessage(
        "Erreur",
        "Le code promo special n'est pas valable pour l'offre annuelle",
        "error",
      );
      return;
    }

    if (paymentMethod === "upload" && !paymentFile) {
      snackbarContext?.showMessage(
        "Erreur",
        "Veuillez televerser un recu de paiement",
        "error",
      );
      return;
    }

    const formData = new FormData();
    formData.append("selectedPeriod", selectedPeriod);
    formData.append("paymentMethod", paymentMethod);
    if (promoCode) {
      formData.append("promoCode", promoCode);
    }
    if (paymentMethod === "upload" && paymentFile) {
      formData.append("paymentImage", paymentFile);
    }

    sendOfferService(selectedOffer.id, formData, "")
      .then(() => {
        setIsPeriodModalOpen(false);
        setPaymentFile(null);
        setSelectedOffer(null);
        setPaymentMethod("upload");
        snackbarContext?.showMessage(
          "Succes",
          "Votre demande a ete envoyee avec succes",
          "success",
        );
        fetchData();
      })
      .catch((e: any) => {
        console.log(e);
        snackbarContext?.showMessage(
          "Erreur",
          "Une erreur est survenue lors de l'envoi de la demande",
          "error",
        );
      });
  };

  const handleClosePeriodModal = () => {
    setIsPeriodModalOpen(false);
    setPaymentFile(null);
    setSelectedOffer(null);
    setPaymentMethod("upload");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50/50 via-white to-teal-50/30">
      <div
        className={`flex flex-col items-center gap-8 w-full px-4 py-10 max-w-7xl mx-auto ${
          loading
            ? "justify-center items-center h-[60vh]"
            : data.length === 0
              ? "justify-center items-center h-[60vh]"
              : ""
        }`}
      >
        {/* Popup de selection de la periode */}
        <Dialog
          open={isPeriodModalOpen}
          onClose={handleClosePeriodModal}
          fullWidth
          maxWidth="xs"
          PaperProps={{
            style: { borderRadius: 16, overflow: "hidden" },
          }}
        >
          <DialogTitle className="flex items-center justify-between text-white bg-primary">
            <span className="text-xl font-montserrat_semi_bold">
              Selection de la periode
            </span>
            <IconButton onClick={handleClosePeriodModal} className="text-white">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className="px-4 py-6">
            <div
              className="mb-8"
              ref={(el) => {
                if (el && isPeriodModalOpen) {
                  setTimeout(
                    () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
                    100,
                  );
                }
              }}
            >
              <label
                htmlFor="promo-code-input"
                className="block mb-2 text-base font-bold text-primary"
              >
                Code Promo (optionnel)
              </label>
              <input
                id="promo-code-input"
                type="text"
                value={promoCode}
                onChange={(e) => {
                  const value = e.target.value;
                  setPromoCode(value);
                  const isSpecial =
                    value === specialPromoCode && Boolean(specialPromoCode);
                  setIsSpecialPromoActive(isSpecial);
                  if (isSpecial && selectedPeriod === "YEARLY") {
                    setSelectedPeriod("MONTHLY");
                  }
                }}
                placeholder="Entrez votre code promo ici"
                className="w-full px-4 py-3 text-lg font-semibold border-2 rounded-lg border-primary focus:outline-none focus:ring-2 focus:ring-primary bg-yellow-50"
                style={{ letterSpacing: "0.1em" }}
              />
              {isSpecialPromoActive && (
                <span className="block mt-3 text-xs font-semibold text-green-700">
                  Code special actif - periodes annuelles desactivees
                </span>
              )}
            </div>
            <div className="mb-6">
              <Typography variant="h6" className="mb-3 font-montserrat_medium">
                Choisissez la periode d'abonnement
              </Typography>
              <div className="flex justify-center gap-2 mb-4">
                {["MONTHLY", "TRIMESTER", "SEMESTER", "YEARLY"].map((period) => {
                  const periodDisabled =
                    isSpecialPromoActive && period === "YEARLY";
                  return (
                    <button
                      key={period}
                      className={`px-4 py-2 text-sm font-bold rounded-lg border transition-all duration-300 ${
                        selectedPeriod === period
                          ? "bg-primary text-white border-primary shadow"
                          : "bg-white text-primary border-primary hover:bg-blue-50"
                      } ${periodDisabled ? "opacity-60 cursor-not-allowed" : ""}`}
                      onClick={() =>
                        !periodDisabled && setSelectedPeriod(period as any)
                      }
                      disabled={periodDisabled}
                    >
                      {period === "MONTHLY" && "Mensuel"}
                      {period === "TRIMESTER" && "Trimestriel"}
                      {period === "SEMESTER" && "Semestriel"}
                      {period === "YEARLY" && "Annuel"}
                    </button>
                  );
                })}
              </div>
            </div>
            <div className="p-4 mb-6 rounded-lg bg-gray-50">
              <Typography variant="h6" className="mb-4 font-montserrat_semi_bold">
                Details du paiement
              </Typography>
              <div className="mb-6">
                <Typography className="mb-3 font-montserrat_medium">
                  Methode de paiement: Televerser un recu
                </Typography>
              </div>
              <div
                className="flex flex-col items-center justify-center w-full transition-colors border-2 border-gray-300 border-dashed rounded-lg cursor-pointer h-28 sm:h-32 bg-gray-50 hover:bg-gray-100"
                onClick={() =>
                  document.getElementById("payment-file-input")?.click()
                }
              >
                <div className="flex flex-col items-center justify-center px-4">
                  <CloudUploadIcon className="w-6 h-6 mb-2 text-gray-500 sm:w-8 sm:h-8" />
                  <p className="mb-1 text-xs text-center text-gray-500 sm:mb-2 sm:text-sm">
                    <span className="font-semibold">Cliquez pour televerser</span>
                  </p>
                  <p className="text-xs text-center text-gray-500">
                    JPG, PNG ou PDF (MAX. 5MB)
                  </p>
                </div>
                <input
                  type="file"
                  id="payment-file-input"
                  className="hidden"
                  onChange={handleFileChange}
                  accept="image/*,.pdf"
                />
              </div>
              {paymentFile && (
                <div className="p-2 mt-3 border border-green-200 rounded-lg bg-green-50">
                  <p className="text-xs font-medium text-green-700 truncate sm:text-sm">
                    Fichier selectionne: {paymentFile.name}
                  </p>
                </div>
              )}
            </div>
            <div className="flex flex-col justify-end space-y-3 sm:flex-row sm:space-y-0 sm:space-x-3">
              <Button
                variant="outlined"
                onClick={handleClosePeriodModal}
                className="order-2 w-full px-4 py-2 text-sm text-gray-700 border-gray-300 rounded-lg sm:w-auto sm:px-6 sm:py-2 sm:text-base font-montserrat_medium sm:order-1"
              >
                Annuler
              </Button>
              <Button
                variant="contained"
                onClick={handlePeriodConfirm}
                disabled={paymentMethod === "upload" && !paymentFile}
                className={`w-full sm:w-auto font-montserrat_semi_bold bg-primary text-white py-3 sm:py-2 px-4 sm:px-6 rounded-lg text-sm sm:text-base order-1 sm:order-2 ${
                  paymentMethod === "upload" && !paymentFile
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:bg-primary-dark"
                }`}
              >
                {paymentMethod === "online"
                  ? "Payer en ligne"
                  : "Confirmer et Envoyer"}
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Interface principale */}
        {loading ? (
          <div className="flex flex-col items-center justify-center w-full min-h-[60vh]">
            <div className="relative">
              <div className="w-24 h-24 border-4 border-primary/10 border-t-primary rounded-full animate-spin"></div>
              <img src={Logo} alt="Logo" className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 object-contain" />
            </div>
            <h2 className="text-sm font-black text-primary uppercase tracking-[0.4em] mt-8 animate-pulse">
              Chargement des offres...
            </h2>
          </div>
        ) : isConfirmModal && selectedOffer ? (
          <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-title/20 backdrop-blur-sm">
            <div className="w-full max-w-md bg-white rounded-[3rem] shadow-2xl overflow-hidden p-10 flex flex-col items-center">
              <div className="w-20 h-20 bg-primary/10 rounded-3xl flex items-center justify-center text-primary mb-8">
                 <CheckCircleIcon style={{ fontSize: 40 }} />
              </div>
              <h2 className="text-2xl font-black text-title uppercase tracking-tight text-center mb-2">
                {selectedOffer.title}
              </h2>
              <p className="text-[10px] font-bold text-primary uppercase tracking-[0.4em] mb-6">Offre gratuite</p>
              
              <p className="text-text/60 font-medium text-center mb-10 leading-relaxed px-4">
                Vous êtes sur le point de rejoindre cette offre gratuitement. Voulez-vous confirmer votre inscription ?
              </p>
              
              <div className="flex flex-col w-full gap-4">
                <button
                  onClick={() => { sendOfferService(selectedOffer.id, {}, "").then(() => { fetchData(); setIsConfirmModal(false); setSelectedOffer(null); snackbarContext?.showMessage("Succès", "Bienvenue dans l'offre !", "success"); }); }}
                  className="w-full py-5 bg-primary text-white font-black text-[11px] uppercase tracking-[0.3em] rounded-2xl shadow-xl shadow-primary/20 hover:scale-[1.02] transition-all"
                >
                  Confirmer l'adhésion
                </button>
                <button
                  onClick={() => { setIsConfirmModal(false); setSelectedOffer(null); }}
                  className="w-full py-4 text-text/30 font-black text-[10px] uppercase tracking-[0.3em] hover:text-red-500 transition-all"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="px-4 md:px-10 pb-20">
            {data && data.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10 max-w-[1400px] mx-auto">
                {data.map((offer: any, index: number) => (
                  <div key={index} className="flex justify-center">
                    <OfferCard
                      offer={offer}
                      onclick={() => handleOfferClick(offer)}
                      onUpdateOffer={handleUpdateOffer}
                      onDeleteOffer={handleUpdateAfterDelete}
                      onSubscribed={fetchData}
                    />
                  </div>
                ))}

                {role === "ROLE_ADMIN" && (
                  <div className="flex justify-center">
                    <button
                      onClick={handleOpenModal}
                      className="w-full max-w-[380px] h-[600px] flex flex-col items-center justify-center gap-6 bg-gray-50/50 border-4 border-dashed border-gray-100 rounded-[3rem] transition-all duration-500 hover:border-primary/40 hover:bg-white hover:shadow-2xl hover:-translate-y-3 group overflow-hidden relative"
                    >
                      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
                      <div className="relative z-10 flex flex-col items-center">
                         <div className="w-24 h-24 bg-white rounded-[2.5rem] shadow-sm flex items-center justify-center text-text/20 group-hover:text-primary group-hover:scale-110 transition-all duration-700 border border-gray-50">
                            <AddIcon style={{ fontSize: 40 }} />
                         </div>
                         <h3 className="mt-8 text-xl font-black text-title uppercase tracking-tight">Ajouter Offre</h3>
                         <p className="mt-2 text-[10px] font-bold text-text/30 uppercase tracking-[0.2em]">Créer un nouveau forfait</p>
                      </div>
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center min-h-[40vh] text-center border-2 border-dashed border-gray-100 rounded-[3rem] p-20 bg-gray-50/30">
                <div className="w-20 h-20 bg-gray-100 rounded-3xl flex items-center justify-center text-text/20 text-4xl mb-8">
                  <span className="mb-2">:(</span>
                </div>
                <h3 className="text-xl font-black text-title uppercase tracking-tight mb-2">Aucune offre disponible</h3>
                <p className="text-text/40 font-medium mb-10 max-w-sm">Revenez plus tard pour découvrir nos nouveaux forfaits d'apprentissage.</p>
                {role === "ROLE_ADMIN" && (
                  <button onClick={handleOpenModal} className="px-10 py-5 bg-primary text-white font-black text-[11px] uppercase tracking-[0.3em] rounded-2xl shadow-xl shadow-primary/20 hover:-translate-y-1 transition-all">
                    Créer la première offre
                  </button>
                )}
              </div>
            )}
          </div>
        )}

        <OfferStudentModal
          open={isModalOpen}
          onClose={handleCloseModal}
          modalTitle="Nouvelle Offre"
          buttonText="Publier l'Offre"
          onButtonClick={handleAction}
        />

        {/* Profile Dialog Modernized */}
        <Dialog
          open={Boolean(selectedProfile)}
          onClose={handleCloseProfileDialog}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            className: "rounded-[3rem] p-10 shadow-2xl border border-gray-50 overflow-hidden"
          }}
        >
           <div className="flex flex-col items-center relative">
              <button onClick={handleCloseProfileDialog} className="absolute -top-4 -right-4 w-10 h-10 flex items-center justify-center rounded-2xl bg-gray-50 text-text/30 hover:text-red-500 transition-all">
                <span className="text-2xl font-light">&times;</span>
              </button>
              
              <div className="w-24 h-24 bg-primary/10 rounded-[2rem] flex items-center justify-center text-primary mb-8 shadow-inner">
                 <PersonIcon style={{ fontSize: 48 }} />
              </div>
              
              <h2 className="text-2xl font-black text-title uppercase tracking-tight mb-1">{selectedProfile?.fullName}</h2>
              <p className="text-[10px] font-bold text-primary uppercase tracking-[0.4em] mb-10">Détails du membre</p>
              
              <div className="w-full space-y-4">
                 <div className="flex items-center gap-6 p-6 bg-gray-50 rounded-3xl border border-gray-100/50 group hover:bg-white hover:border-primary/20 transition-all">
                    <div className="w-12 h-12 bg-white rounded-2xl shadow-sm flex items-center justify-center text-primary group-hover:scale-110 transition-all">
                       <MailOutlineOutlinedIcon fontSize="small" />
                    </div>
                    <div className="flex flex-col">
                       <span className="text-[9px] font-black text-text/30 uppercase tracking-widest mb-1">Email</span>
                       <span className="font-bold text-title">{selectedProfile?.email}</span>
                    </div>
                 </div>
                 
                 <div className="flex items-center gap-6 p-6 bg-gray-50 rounded-3xl border border-gray-100/50 group hover:bg-white hover:border-primary/20 transition-all">
                    <div className="w-12 h-12 bg-white rounded-2xl shadow-sm flex items-center justify-center text-primary group-hover:scale-110 transition-all">
                       <PhoneIcon fontSize="small" />
                    </div>
                    <div className="flex flex-col">
                       <span className="text-[9px] font-black text-text/30 uppercase tracking-widest mb-1">Téléphone</span>
                       <span className="font-bold text-title">{selectedProfile?.phoneNumber}</span>
                    </div>
                 </div>
              </div>
              
              <button 
                 onClick={handleCloseProfileDialog}
                 className="mt-10 w-full py-5 bg-title text-white font-black text-[11px] uppercase tracking-[0.3em] rounded-2xl shadow-xl shadow-title/20 hover:bg-primary transition-all duration-500"
              >
                 Fermer le profil
              </button>
           </div>
        </Dialog>
      </div>
    </div>
  );
};

export default OfferStudent;

